import React from 'react';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
import { CASE_STATUS_SUBMITTED } from './CaseConstants';

const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/submitted' },
  { label: 'Awaiting Approval', to: '/user/case/awaiting-approval' },
];

const AwaitingApprovalCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.awaiting_approval_case_list_title}
          caseStatus={CASE_STATUS_SUBMITTED}
          breadCrumbItems={BREAD_CRUMBS}
          showHasFilter={true}
          showProStatusFilter={false}
          forcedProStatus="submited"
        />
      </div>
    </div>
  );
};

export default AwaitingApprovalCases;
